// AppShell — global layout wrapping TopBar + SidebarNav (primary nav) + Footer.
//
// calc-sidebar integration (Stage 6g): the app's 7 top-level groups exceed the
// 5-item cap of a horizontal tab bar, so <SidebarNav> is the primary navigation.
// Each screen renders as an always-mounted content panel (state preserved across
// navigation — UX Invariant #8). URL hash persistence (#nav/<screen>) is handled
// by SidebarNav's internal useHashNav; the store's navigate() syncs the hash for
// code-driven navigation (buttons/links inside screens).

import { SidebarNav } from 'calc-sidebar';
import type { SidebarItemDef } from 'calc-sidebar';
import { TopBar } from './TopBar';
import { Footer } from './Footer';
import { PanelErrorBoundary } from '../common/ErrorBoundary';
import { Dashboard } from '../../screens/Dashboard';
import { CapTableScreen } from '../../screens/CapTable';
import { ValuationBuilder } from '../../screens/ValuationBuilder';
import { Results } from '../../screens/Results';
import { Analysis } from '../../screens/Analysis';
import { Report } from '../../screens/Report';
import { Settings } from '../../screens/Settings';

export function AppShell() {
  const items: SidebarItemDef[] = [
    { id: 'dashboard', label: 'Dashboard', content: <PanelErrorBoundary boundaryName="Dashboard"><Dashboard /></PanelErrorBoundary> },
    { id: 'capTable', label: 'Cap Table', content: <PanelErrorBoundary boundaryName="Cap Table"><CapTableScreen /></PanelErrorBoundary> },
    { id: 'builder', label: 'Builder', content: <PanelErrorBoundary boundaryName="Valuation Builder"><ValuationBuilder /></PanelErrorBoundary> },
    { id: 'results', label: 'Results', content: <PanelErrorBoundary boundaryName="Results"><Results /></PanelErrorBoundary> },
    { id: 'analysis', label: 'Analysis', content: <PanelErrorBoundary boundaryName="Analysis"><Analysis /></PanelErrorBoundary> },
    { id: 'report', label: 'Report', content: <PanelErrorBoundary boundaryName="Report"><Report /></PanelErrorBoundary> },
    { id: 'settings', label: 'Settings', content: <PanelErrorBoundary boundaryName="Settings"><Settings /></PanelErrorBoundary> },
  ];

  return (
    <div className="app-shell">
      <TopBar />
      <SidebarNav
        section="nav"
        defaultItem="dashboard"
        stickyTop="var(--topbar-height)"
        ariaLabel="Primary"
        items={items}
      />
      <Footer />
    </div>
  );
}
